import React from 'react';
import Icon from '../../../components/AppIcon';

const SortControls = ({ sortBy, onSortChange, viewMode, onViewModeChange, resultCount }) => {
  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'popularity', label: 'Most Popular' },
    { value: 'newest', label: 'Newest Releases' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'rating', label: 'Highest Rated' }
  ];

  return (
    <div className="flex items-center gap-3">
      <select
        value={sortBy}
        onChange={(e) => onSortChange(e?.target?.value)}
        className="text-sm rounded-lg px-3 py-2 border-none outline-none cursor-pointer"
        style={{
          backgroundColor: 'rgba(255,255,255,0.12)',
          color: '#e2e8f0',
          minWidth: '160px'
        }}
      >
        {sortOptions?.map(opt => (
          <option key={opt?.value} value={opt?.value} style={{ backgroundColor: '#1e3a5f', color: '#e2e8f0' }}>
            {opt?.label}
          </option>
        ))}
      </select>
      <div
        className="hidden md:flex items-center gap-1 rounded-lg p-1"
        style={{ backgroundColor: 'rgba(255,255,255,0.12)' }}
      >
        <button
          onClick={() => onViewModeChange('grid')}
          className="p-1.5 rounded transition-all"
          style={{
            backgroundColor: viewMode === 'grid' ? '#fbbf24' : 'transparent',
            color: viewMode === 'grid' ? '#0f172a' : '#94a3b8'
          }}
          aria-label="Grid view"
          aria-pressed={viewMode === 'grid'}
        >
          <Icon name="Grid" size={18} />
        </button>
        <button
          onClick={() => onViewModeChange('list')}
          className="p-1.5 rounded transition-all"
          style={{
            backgroundColor: viewMode === 'list' ? '#fbbf24' : 'transparent',
            color: viewMode === 'list' ? '#0f172a' : '#94a3b8'
          }}
          aria-label="List view"
          aria-pressed={viewMode === 'list'}
        >
          <Icon name="List" size={18} />
        </button>
      </div>
    </div>
  );
};

export default SortControls;